import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Dashboard: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path d="M4 15a8 8 0 1 1 16 0h2c0-5.523-4.477-10-10-10S2 9.477 2 15h2z" />
    <path d="M14 16a2 2 0 1 1-2.268-1.982l1.216-2.386.946-1.893 1.79.894-.637 1.273.005.002-.319.625L13.6 14.8c.251.334.4.75.4 1.2z" />
  </SvgIcon>
)
